import React, { useState } from 'react';
const CardStep1 = ({ setCurrentStep }) => {
   const [formData, setFormData] = useState({
      buyAmount: '',
      cryptocurrency: 'PROPT (POLYGON)'
   });
   const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prevState => ({
         ...prevState,
         [name]: value
      }));
   };
   const isFormValid = formData.buyAmount.trim() !== '';
   return (
      <div className="modal_content_body px-4">
         <div className="withdraw-crypto-form">
            <h3 className="ppt_form_title mb-4 text-center">Credit / Debit card payment</h3>
            <div className="d-flex flex-column align-items-center">
               <div className="d-flex align-items-center mb-4">
                  <div className="d-flex align-items-center" style={{ fontSize: '68px' }}><span className="text-dark">$</span>
                     <input
                        type="text"
                        name="buyAmount"
                        value={formData.buyAmount}
                        onChange={handleInputChange}
                        placeholder="000000"
                        style={{
                           fontSize: '68px',
                           maxWidth: '282px',
                           outline: 'none'
                        }}
                        className="border-0 bg-none"
                     />
                  </div>
                  <div className="">
                     <div className="d-flex align-items-center flex-column justify-content-center">
                        <span className="ppt_btn_convert_crypto pointer" style={{ cursor: 'pointer' }}><svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g clip-path="url(#clip0_229_16618)">
                              <path d="M44.1498 16.8444C44.6388 17.2443 44.7105 17.9641 44.3109 18.4527L24.3491 42.8595L31.2539 42.1678C31.8824 42.1048 32.4422 42.5627 32.5049 43.191C32.5364 43.505 32.4376 43.8022 32.2526 44.0285C32.0675 44.2548 31.7958 44.4105 31.4817 44.442L21.8315 45.4088C21.203 45.4718 20.6432 45.0139 20.5805 44.3856L19.6137 34.7354C19.5507 34.1069 20.0086 33.5471 20.6369 33.4843C21.2651 33.4216 21.8252 33.8792 21.8879 34.5075L22.5796 41.4123L42.5414 17.0055C42.941 16.5169 43.6607 16.4444 44.1498 16.8444ZM30.9257 6.46133L21.2755 7.42814C20.647 7.4911 20.1891 8.05093 20.2523 8.67918C20.3154 9.30743 20.8751 9.76552 21.5033 9.70237L28.408 9.01063L8.4463 33.4174C8.04668 33.906 8.11838 34.6258 8.60743 35.0258C9.09648 35.4258 9.81618 35.3532 10.2158 34.8646L30.1775 10.4579L30.8693 17.3626C30.9323 17.9911 31.4921 18.4489 32.1203 18.3858C32.4344 18.3543 32.7061 18.1986 32.8912 17.9723C33.0762 17.746 33.175 17.4488 33.1435 17.1348L32.1767 7.48453C32.114 6.85624 31.5539 6.39819 30.9257 6.46133Z" fill="black"></path>
                           </g>
                           <defs>
                              <clipPath id="clip0_229_16618">
                                 <rect width="36.5755" height="36.5755" fill="white" transform="translate(0.644531 28.5132) rotate(-50.721)"></rect>
                              </clipPath>
                           </defs>
                        </svg>
                        </span
                        ><b>PROPT</b>
                     </div>
                  </div>
               </div>
               <div className="w-100 mb-5" style={{ maxWidth: '370px' }}>
                  <div className="position-relative">
                     <select
                        className='form-select border-0'
                        name="cryptocurrency"
                        value={formData.cryptocurrency}
                        onChange={handleInputChange}
                        style={{
                           fontSize: '12px',
                        }}
                     >
                        <option value="PROPT (POLYGON)">PROPT (POLYGON)</option>
                        <option value="PROPT (ETHEREUM)">PROPT (ETHEREUM)</option>
                     </select>

                  </div>
               </div>
               <button
                  className="ppt_btn_primary alt"
                  onClick={() => setCurrentStep(2)}
                  disabled={!isFormValid}

               >
                  Continue
               </button>

            </div>
         </div>
      </div>
   );
};
export default CardStep1;